export default "__VITE_ASSET__BYMJHX9f__ 400w, __VITE_ASSET__DB4l$dlK__ 800w, __VITE_ASSET__DLlYnOpu__ 1024w";